<table mat-table [dataSource]="dataSource">
  <!-- Expand Column -->
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        *ngIf="isIndependentsRow(element)"
        (click)="toggleIndependents()"
        [attr.aria-label]="'Toggle independents expansion'"
      >
        <mat-icon>{{
          isIndependentsExpanded ? "expand_less" : "expand_more"
        }}</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container
    *ngFor="let col of columns; let i = index"
    matColumnDef="{{ col.column }}"
  >
    <th mat-header-cell *matHeaderCellDef>
      <div *ngIf="col.isRightJustify === false">{{ col.label }}</div>
      <div class="value-justify-right" *ngIf="col.isRightJustify === true">
        {{ col.label }}
      </div>
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      [ngClass]="{ 'independent-detail-row': isIndividualIndependent(element) }"
    >
      <div *ngIf="col.isColour" [style.width.px]="col.minWidth">
        <mat-icon
          class="party-colour"
          [ngStyle]="{ color: element.colourCode }"
        >
          rectangle
        </mat-icon>
      </div>
      <div
        [style.min-width.px]="col.minWidth"
        class="value-justify-right"
        *ngIf="col.isRightJustify && col.isPercent === false"
      >
        {{ element[col.column] | number }}
      </div>
      <div
        [style.min-width.px]="col.minWidth"
        class="value-justify-right"
        *ngIf="col.isPercent"
      >
        <div *ngIf="col.isColourBar"></div>
        {{
          (element[col.column] === null ? "n/a" : element[col.column]) / 100
            | percent : "1.1-1"
        }}
      </div>
      <div
        [style.min-width.px]="col.minWidth"
        *ngIf="col.isRightJustify === false && col.isColour === false"
      >
        {{ element[col.column] }}
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    [ngClass]="{ 'table-row': isSmallTable }"
  ></tr>
</table>
